import { Language } from "@openeducation/hr-rn-shared-types";
import { getTranslatedMonth } from "@openeducation/hr-js-utils";

export const generateMonthLabels = (language: Language) =>
  Array.from({ length: 12 }).map((_, i) =>
    getTranslatedMonth(new Date(2000, i), language, true).toUpperCase()
  );
